import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert } from 'reactstrap';

import BackendApiService from '../../services/BackendApiService';
import FirmaDocumentosList from '../firmas-documentos-list/FirmaDocumentosList';
import ModalMessage from '../modal-message/ModalMessage';
import excelIcon from '../../theme/assets/ico-excel.png';
import { applySelectMandateSelection } from '../../helpers/prevStateUpdates';
import logCaughtException from '../../helpers/logCaughtException';

class FirmasDocumentosListContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signDocumentsList: [],
      params: this.props.filters || {},
      fetchParams: ['where', 'per_page', 'page', 'sorted'],
      exporting: false,
      exportingExcel: false,
      showMessage: false,
      exportResult: '',
      emp_mail: '',
      selected: {},
      selectedAll: false,
    };
    this.fetchData = this.fetchData.bind(this);
    this.download = this.download.bind(this);
    this.signDocumentListComponentRef = React.createRef();
  }

  componentWillReceiveProps(props) {
    if (props.massiveApprovalFinished) {
      this.setState({ selected: {}, selectedAll: false });
    }
  }

  async fetchData(params) {
    params = Object.assign(this.state.params, params);
    params = this.filterParams(params);
    const signDocumentsList = await BackendApiService.getFirmasDocumentosList(params);
    this.setState({ params, signDocumentsList, selectedAll: false });
    this.props.updateCount(signDocumentsList.extra.recordsFiltered);
    return signDocumentsList;
  }

  filterParams(params) {
    const filtered = Object.keys(params)
      .filter((key) => this.state.fetchParams.includes(key))
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});
    return filtered;
  }

  async exportData(format, from) {
    const { params } = this.state;
    params.format = format;
    params.from = from;
    const exportResult = await BackendApiService.getFirmasDocumentosList(params);
    return exportResult.data;
  }

  download(format, from) {
    this.setState({ exportingExcel: true });
    const link = document.createElement('a');
    link.target = '_blank';
    this.exportData(format, from)
      .then((response) => {
        this.setState({ exporting: false, exportingExcel: false, exportResult: response.url });
      })
      .catch(() => {
        alert('Error exportando datos');
        this.setState({ exporting: false });
      });
  }

  refreshFilters(filters) {
    this.setState({ params: filters });
    setTimeout(() => {
      this.signDocumentListComponentRef.current.reloadData();
    }, 100);
  }

  componentDidMount() {
    // React ignores whatever componentDidMount returns, so the promise has to
    // be terminated here or a rejected session load becomes an unhandled one.
    this.loadSessionData().catch(logCaughtException);
  }

  async loadSessionData() {
    const session = await BackendApiService.getSessionData();
    if (session) {
      this.setState({
        emp_mail: session.usuario.mail,
      });
    }
  }

  selectMandate = (itemId, item, isChecked) => {
    const documentsData = this.state.signDocumentsList.data;
    this.setState(
      (prevState) => applySelectMandateSelection(
        prevState.selected,
        prevState.selectedAll,
        documentsData,
        itemId,
        item,
        isChecked,
      ),
      () => {
        this.props.selectedCallback(Object.keys(this.state.selected));
      },
    );
  };

  render() {
    const listActions = [];
    switch (this.props.tab) {
      case 'signed': {
        listActions.push(
          <div key="signed-view">
            {this.state.exportResult
              ? (
                <a
                  key="export-xls-download"
                  href={this.state.exportResult}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => this.setState({ exportResult: '' })}
                  className="btn donwload-button btn-sm actions"
                  disabled={this.state.exporting}
                >
                  <FontAwesomeIcon icon="file-download" />
                  Descargar Excel
                </a>
              )
              : (
                <button
                  type="button"
                  key="export-xls"
                  className="btn btn-gray btn-sm actions"
                  onClick={() => this.download('xlsx', 'signed')}
                  disabled={this.state.exporting}
                >
                  <img src={excelIcon} alt="Excel icon" />
                  {this.state.exportingExcel ? 'Exportando...' : 'Exportar a Excel'}
                </button>
              )}
          </div>,
        );
        break;
      }
      case 'forSign': {
        listActions.push(
          <div key="repertory-view">
            {this.state.exportResult
              ? (
                <a
                  key="export-xls-download"
                  href={this.state.exportResult}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => this.setState({ exportResult: '' })}
                  className="btn donwload-button btn-sm actions"
                  disabled={this.state.exporting}
                >
                  <FontAwesomeIcon icon="file-download" />
                  Descargar Excel
                </a>
              )
              : (
                <button
                  type="button"
                  key="export-xls"
                  className="btn btn-gray btn-sm actions"
                  onClick={() => this.download('xlsx', null)}
                  disabled={this.state.exportingAll}
                >
                  <img src={excelIcon} alt="Excel icon" />
                  {this.state.exportingAll ? 'Exportando...' : 'Exportar a Excel'}
                </button>
              )}
          </div>,
        );
        break;
      }
      case 'full': {
        listActions.push(
          <div key="repertory-view">
            {this.state.exportResult
              ? (
                <a
                  key="export-xls-download"
                  href={this.state.exportResult}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => this.setState({ exportResult: '' })}
                  className="btn donwload-button btn-sm actions"
                  disabled={this.state.exporting}
                >
                  <FontAwesomeIcon icon="file-download" />
                  Descargar Excel
                </a>
              )
              : (
                <button
                  type="button"
                  key="export-xls"
                  className="btn btn-gray btn-sm actions"
                  onClick={() => this.download('xlsx', 'full')}
                  disabled={this.state.exporting}
                >
                  <img src={excelIcon} alt="Excel icon" />
                  {this.state.exportingExcel ? 'Exportando...' : 'Exportar a Excel'}
                </button>
              )}
          </div>,
        );
        break;
      }
      default: {
        break;
      }
    }
    let successMessage = '';
    if (this.props.massiveApprovalFinished && this.props.tab === 'forApproval') {
      successMessage = (
        <Alert color="success" isOpen>
          Se aprobaron satisfactoriamente los mandatos seleccionados
        </Alert>
      );
    }

    return (
      <div>
        {successMessage}
        <FirmaDocumentosList
          ref={this.signDocumentListComponentRef}
          id={this.props.id}
          selected={this.state.selected}
          selectedAll={this.state.selectedAll}
          selectRow={this.selectMandate}
          fetchDataCallback={this.fetchData}
          approving={this.props.approving}
          approvingData={this.props.approvingData}
        />
        {this.state.showMessage
          ? <ModalMessage message={`Se esta generando el paquete que se enviará al correo: ${this.state.emp_mail}`} messageType="success" />
          : ''}
        <div className="action-buttons">
          {listActions}
        </div>
      </div>
    );
  }
}

FirmasDocumentosListContainer.propTypes = {
  id: PropTypes.string,
  tab: PropTypes.string,
  filters: PropTypes.object,
  updateCount: PropTypes.func,
  selectedCallback: PropTypes.func,
  massiveApprovalFinished: PropTypes.bool,
  approving: PropTypes.bool,
  approvingData: PropTypes.object,
};

export default FirmasDocumentosListContainer;
